export default function PHP_readfile() {
  return (
    <div>
      <h1>PHP_readfile</h1>
    </div>
  );
}
